import React from 'react'
import styled from 'styled-components'
import Image from 'gatsby-image'

import { Rating, LinkType, Productcard } from '../shared'
import { Heart } from '../shared/icons'

import {
  desktopVw,
  mobileVw,
  desktopBreakpoint,
  colors,
  fonts,
} from '../../styles'

export const RelatedProducts = ({ relatedProducts, title }) => {
  return (
    <Wrapper>
      <Title>{title}</Title>
      <ProductGallery className='product-gallery'>
        {relatedProducts && relatedProducts.map((product, i) => (
          <ProductWrapper key={i}>
            <Productcard
              recipePage
              product={{
                ...product,
                thumbnailImage: product.images[0],
              }}
            />
          </ProductWrapper>
        ))}
      </ProductGallery>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  padding: 0 ${mobileVw(16)};

  @media (min-width: ${desktopBreakpoint}) {
    width: ${desktopVw(508)};
    padding: 0 ${desktopVw(130)} 0 ${desktopVw(30)};
  }
`

const ProductGallery = styled.div`
  display: flex;
  padding: ${mobileVw(15)} 0 ${mobileVw(8)};

  @media (min-width: ${desktopBreakpoint}) {
    flex-direction: column;
    padding: 0;
  }
`

const ProductWrapper = styled.div`
  display: flex;
  width: ${desktopVw(350)};
  justify-content: space-between;
  position: relative;
  margin-bottom: ${desktopVw(30)};
  width: 100%;

  p {
    font-size: ${desktopVw(22)};
    line-height: ${desktopVw(24)};
    height: auto;
  }

  .product-wrapper,
  .image-link {
    height: ${desktopVw(216)};
  }

  .text-wrapper {
    margin-left: ${desktopVw(30)};
    > div {
      min-height: 100%;
      > div {
        min-height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
    }
  }

  .image-link {
    margin-bottom: 0;
    width: ${desktopVw(160)};
  }
`

const Title = styled.h2`
  font-family: ${fonts.splandor};
  font-size: ${mobileVw(30)};
  line-height: ${mobileVw(23)};
  margin: 0 0 ${mobileVw(4)};
  color: ${colors.mailleGold};

  @media (min-width: ${desktopBreakpoint}) {
    font-size: ${desktopVw(24)};
    line-height: ${desktopVw(24)};
    margin: 0 0 ${desktopVw(20)};
  }
`
